import Vue from 'vue'
import { extend, ValidationObserver, ValidationProvider, localize } from 'vee-validate'
import * as rules from 'vee-validate/dist/rules'
import en from 'vee-validate/dist/locale/en.json'
import es from 'vee-validate/dist/locale/es.json'
import pt from 'vee-validate/dist/locale/pt_BR.json'

extend('decimal', {
  validate: value => !isNaN(value),
  message: 'The {_field_} field must be an decimal'
})

Object.keys(rules).forEach(rule => {
  extend(rule, {
    ...rules[rule]
  })
})

localize('en', en)
localize('es', es)
localize('pt', pt)

// Register it globally
Vue.component('ValidationProvider', ValidationProvider)
Vue.component('ValidationObserver', ValidationObserver)
